
import { ProcessTypeEnum, TenantUserModel } from '@/libs/Api';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import { Component, Prop, VModel, Vue, Watch } from 'vue-property-decorator';

const shutdownDurations = [
    { id: 1, min: 0, max: 0, name: 'planItems.shutdownZero' },
    { id: 2, min: 0, max: 15, name: 'planItems.shutdownZeroToFifteen' },
    { id: 3, min: 15, max: 30, name: 'planItems.shutdownFifteenToThirty' },
    { id: 4, min: 30, max: 60, name: 'planItems.shutdownThirtyToSixty' },
    { id: 5, min: 60, max: 120, name: 'planItems.shutdownSixtyToOneTwenty' },
    { id: 6, min: 120, max: 180, name: 'planItems.shutdownOneTwentyToOneEighty' },
    { id: 7, min: 180, max: 99999999, name: 'planItems.shutdownMoreThanEighty' },
];
export { shutdownDurations };

@Component({})
export default class ShutdownDurationSelect extends Vue {
    tenantUser: TenantUserModel = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;

    @VModel() innerValue!: number;
    @Prop({ default: '' }) label!: string;
    @Prop() type!: string | Array<string>;
    @Prop() readonly!: boolean;
    @Prop() rules!: [any[]];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: false }) noMarginTop!: boolean;
    @Prop({ default: false }) multiple!: boolean;
    @Prop({ default: false }) all!: boolean;
    @Prop({ default: true }) hideDetails!: boolean;
    @Prop({ default: true }) chips!: boolean;
    @Prop({ default: true }) clearable!: boolean;
    @Prop() placeholder!: string;
    @Prop() attach!: string;
    @Prop() except!: Array<string>;
    @Prop({ default: null }) processType!: ProcessTypeEnum | null;

    @Watch('innerValue')
    innerValueChanged(v: number) {
        this.$emit('change', v);
        this.$emit(
            'onSelect',
            this.items.firstOrDefault((x) => x.id == v)
        );
    }

    get items(): { id: number; min: number; max: number; name: string }[] {
        for (let i = 0; i < shutdownDurations.length; i++) {
            shutdownDurations[i].name = this.$t(shutdownDurations[i].name).toString();
        }
        return shutdownDurations;
    }
}
